import { render } from "./Index.vue?vue&type=template&id=9a98c28a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Assessments/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9a98c28a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9a98c28a', __exports__)) {
    console.log('reload')
    api.reload('9a98c28a', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=9a98c28a", () => {
    console.log('re-render')
    api.rerender('9a98c28a', render)
  })

}


export default __exports__